'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ORDINAL_SUFFIXES = ['th', 'st', 'nd', 'rd'];

var getOrdinal = exports.getOrdinal = function getOrdinal(number) {
  var modulus = number % 100;
  var suffix = ORDINAL_SUFFIXES[(modulus - 20) % 10] || ORDINAL_SUFFIXES[modulus] || ORDINAL_SUFFIXES[0];

  return '' + number + suffix;
};

var padNumber = exports.padNumber = function padNumber(score) {
  var decimal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  return Number.isInteger(score) ? score : score.toFixed(decimal);
};


//////////////////
// WEBPACK FOOTER
// ./common/utils/number-formatting.js
// module id = 137
// module chunks = 0